import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Components/Sidebar/Sidebar";
import "../css/Dash.css";
import { collection, getDocs } from "firebase/firestore";
import db from '../firebase-config';
import { BsCashCoin, BsPeopleFill, BsGraphUpArrow, BsClock } from "react-icons/bs";
import { PiAddressBookBold } from "react-icons/pi";

function Menu() {
  const [prestamosActivos, setPrestamosActivos] = useState(0);
  const [prestamosLiquidados, setPrestamosLiquidados] = useState(0);
  const [capitalTotal, setCapitalTotal] = useState(0);
  const [totalClientes, setTotalClientes] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const obtenerDatos = async () => {
      const [prestamosSnap, clientesSnap] = await Promise.all([
        getDocs(collection(db, "prestamos")),
        getDocs(collection(db, "clientes")),
      ]);

      let activos = 0;
      let liquidados = 0;
      let capital = 0;

      prestamosSnap.forEach(doc => {
        const data = doc.data();
        capital += Number(data.cantidadPrestada) || 0;
        if (data.activo) activos++;
        else liquidados++;
      });

      setPrestamosActivos(activos);
      setPrestamosLiquidados(liquidados);
      setCapitalTotal(capital);
      setTotalClientes(clientesSnap.size);
      setLoading(true);
    };

    obtenerDatos();
  }, []);

  const formatCurrency = (n) =>
    n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });

  return (
    <div className="wrapper">
      <nav>
        <Sidebar />
      </nav>

      <div className="marg">
        <div className="dashboard-header">
          <h1>Panel de control</h1>
          <p>Resumen general del sistema de préstamos</p>
        </div>

        <div className="dashboard-cards">
          <div className="dash-card">
            <div className="dash-card-icon dash-icon-blue">
              <BsCashCoin size={22} />
            </div>
            <div>
              <span className="dash-card-label">Préstamos activos</span>
              <span className="dash-card-value">
                {loading ? prestamosActivos : '—'}
              </span>
            </div>
          </div>

          <div className="dash-card">
            <div className="dash-card-icon dash-icon-green">
              <BsGraphUpArrow size={22} />
            </div>
            <div>
              <span className="dash-card-label">Capital prestado</span>
              <span className="dash-card-value" style={{ fontSize: '1.1rem' }}>
                {loading ? formatCurrency(capitalTotal) : '—'}
              </span>
            </div>
          </div>

          <div className="dash-card">
            <div className="dash-card-icon dash-icon-amber">
              <BsClock size={22} />
            </div>
            <div>
              <span className="dash-card-label">Liquidados</span>
              <span className="dash-card-value">
                {loading ? prestamosLiquidados : '—'}
              </span>
            </div>
          </div>

          <div className="dash-card">
            <div className="dash-card-icon dash-icon-red">
              <BsPeopleFill size={22} />
            </div>
            <div>
              <span className="dash-card-label">Clientes</span>
              <span className="dash-card-value">
                {loading ? totalClientes : '—'}
              </span>
            </div>
          </div>
        </div>

        <p className="dashboard-section-title">Accesos rápidos</p>
        <div className="quick-nav-grid">
          <Link to="/Clientes" className="quick-nav-card">
            <PiAddressBookBold size={32} />
            <span>Clientes</span>
          </Link>
          <Link to="/Prestamos" className="quick-nav-card">
            <BsCashCoin size={32} />
            <span>Préstamos</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Menu;
